import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ArticleRecommendation } from '../../services/trigger-point-recommendations.model';
import { ArticleTagsService } from 'src/app/services/article/article-tags.service';
import { ArticleTagType } from 'src/app/services/yeti-protocol/article';

@Component({
  selector: 'app-article-recommendation-card',
  templateUrl: './article-recommendation-card.component.html',
  styleUrls: ['./article-recommendation-card.component.scss'],
})
export class ArticleRecommendationCardComponent  implements OnInit {

  @Input() article:ArticleRecommendation;
  @Input() context:string;

  @Output() openArticle:EventEmitter<string> = new EventEmitter()

  tags: Array<string> = [];

  constructor(public articleTagsService: ArticleTagsService) { }

  ngOnInit(): void {
    if(this.article?.article){
      const tagTypes = [
        ArticleTagType.journals,
        ArticleTagType.interests,
        ArticleTagType.channels,
        ArticleTagType.language,
        ArticleTagType.fullText
      ];
      this.articleTagsService.getTags(this.article.article, tagTypes, this.context)
        .then(tags => {
          this.tags = tags;
        })
        .catch(err => {
          console.error(err);
        });
    }
  }

  onOpenArticle(): void {
    this.openArticle.next(this.article.id);
  }
}
